'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var WEAK = exports.WEAK = 'weak';
var ADAQUATE = exports.ADAQUATE = 'adaquate';
var STRONG = exports.STRONG = 'strong';
//# sourceMappingURL=strength-constants.js.map